function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.49 11.233l5.527 2.69-.656 1.446-2.415-1.174a6.871 6.871 0 003.138 3.129c3.46 1.687 7.766.125 9.523-3.477.224-.46.401-.941.528-1.436l.086-.374 1.766.359a9.361 9.361 0 01-.76 2.241c-2.188 4.486-7.567 6.437-11.933 4.307a8.68 8.68 0 01-4.06-4.149l-.705 2.827L0 17.196l1.49-5.963zm12.46-9.37a8.67 8.67 0 013.9 3.827l.621-2.487L20 3.63l-1.49 5.963-5.527-2.691.656-1.445 2.743 1.334a6.878 6.878 0 00-3.223-3.307C9.7 1.796 5.393 3.358 3.636 6.96c-.224.46-.4.942-.528 1.437l-.086.373-1.766-.358c.157-.776.413-1.53.76-2.242C4.204 1.685 9.583-.266 13.95 1.863z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearch;